<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="6" sm="12">
        <v-select v-model="queryForm.type" :items="atypes" label="类型" no-data-text="无" outlined dense
          :menu-props="{ bottom: true, offsetY: true }" hide-details>
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="6" sm="12">
        <v-text-field v-model="queryForm.name" label="名称" outlined dense clearable hide-details />
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="6" sm="12">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd">
            <v-icon small>mdi-plus</v-icon> 新增点位
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="name" slot-scope="text, record">
          {{ record.shortname || record.name }}
          <v-btn text tile color="success" v-if="record.hide" @click="show(record._id)">显示</v-btn>
          <v-btn text tile color="error" v-else @click="hide(record._id)">隐藏</v-btn>
        </template>
        <template slot="address" slot-scope="text, record">
          <p>{{ record.title }}</p>
          <p>{{ record.address }}</p>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn v-if="record.editable" text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm v-if="record.removeable" title="删除点位" ok-text="确定" cancel-text="取消"
              @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="400px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select v-model="form.type" :items="types" :rules="[vrules.required]" :disabled="form._id !== ''"
                    no-data-text="无" dense outlined :menu-props="{ bottom: true, offsetY: true }" @change="changeType">
                    <template v-slot:label>
                      类型 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-if="form.type === '1'" v-model="form.name" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      邮局
                      <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                  <v-autocomplete v-if="form.type === '2'" v-model="form.chargingpile" :items="chargingpiles"
                    :disabled="form._id !== ''" :rules="[vrules.required]" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }" @change="changeChargingPile">
                    <template v-slot:label>
                      充电桩 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-if="form.type === '3'" v-model="form.vehiclehead" :items="vehicleheads"
                    :disabled="form._id !== ''" :rules="[vrules.required]" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }" @change="changeVehicleHead">
                    <template v-slot:label>
                      车头 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-if="form.type === '4'" v-model="form.vehiclebody" :items="vehiclebodys"
                    :disabled="form._id !== ''" :rules="[vrules.required]" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }" @change="changeVehicleBody">
                    <template v-slot:label>
                      挂箱 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete v-if="form.type === '5'" v-model="form.vehicleouter" :items="vehicleouters"
                    :disabled="form._id !== ''" :rules="[vrules.required]" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }" @change="changeVehicleOuter">
                    <template v-slot:label>
                      整车 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.shortname" outlined dense>
                    <template v-slot:label>
                      简称
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.lnglat" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      坐标
                      <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.address" rows="2" outlined dense>
                    <template v-slot:label>
                      详细地址
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.desc" outlined dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "MapLocation",
  data() {
    return {
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      queryForm: {
        type: "ALL",
        name: "",
      },
      types: [
        { text: '邮局', value: '1' },
        { text: '充电桩', value: '2' },
        { text: '车头', value: '3' },
        { text: '挂箱', value: '4' },
        { text: '整车', value: '5' },
      ],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 120, align: "center" },
        { title: "类型", dataIndex: "typename", scopedSlots: { customRender: "typename" }, width: 100, align: "center" },
        { title: "坐标", dataIndex: "lnglat", scopedSlots: { customRender: "lnglat" }, width: 120, align: "center" },
        { title: "详细地址", dataIndex: "address", scopedSlots: { customRender: "address" }, width: 120, align: "center" },
        { title: "操作时间", dataIndex: "optime", scopedSlots: { customRender: "optime" }, width: 180, align: "center" },
        { title: "操作人", dataIndex: "opby", scopedSlots: { customRender: "opby" }, width: 120, align: "center" },
        { title: "备注", dataIndex: "desc", scopedSlots: { customRender: "desc" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      valid: true,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {},
      chargingpiles: [],
      vehicleheads: [],
      vehiclebodys: [],
      vehicleouters: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    atypes() {
      return [
        { text: '所有', value: 'ALL' },
        ...this.types,
      ];
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  activated() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/location/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list.map(n => {
            return {
              ...n,
              typename: this.atypes.find(m => m.value === n.type)?.text || n.type,
            }
          });
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.chargingpiles = res.data.chargingpiles;
          this.vehicleheads = res.data.vehicleheads;
          this.vehiclebodys = res.data.vehiclebodys;
          this.vehicleouters = res.data.vehicleouters;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        type: "",
        name: "",
        chargingpile: "",
        vehiclehead: "",
        vehiclebody: "",
        shortname: "",
        lnglat: "",
        address: "",
        desc: "",
      };
      this.modeltitle = "新增位置";
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        type: item.type,
        name: item.name,
        chargingpile: item.chargingpile,
        vehiclehead: item.vehiclehead,
        vehiclebody: item.vehiclebody,
        shortname: item.shortname,
        lnglat: item.lnglat,
        address: item.address,
        desc: item.desc,
      };
      this.modeltitle = "编辑位置";
      this.model = true;
    },
    changeType(v) {
      console.log('changeType', v);
      this.form = {
        _id: "",
        type: v,
        name: "",
        chargingpile: "",
        vehiclehead: "",
        vehiclebody: "",
        shortname: "",
        lnglat: "",
        address: "",
        desc: "",
      };
    },
    changeChargingPile(v) {
      console.log('changeChargingPile', v);
      let chargingpile = this.chargingpiles.find(n => n.value === v);
      this.form = {
        _id: "",
        type: this.form.type,
        name: chargingpile.text,
        chargingpile: v,
        vehiclehead: "",
        vehiclebody: "",
        shortname: "",
        lnglat: chargingpile.lnglat,
        address: chargingpile.address,
        desc: "",
      };
    },
    changeVehicleHead(v) {
      console.log('changeVehicleHead', v);
      let vehiclehead = this.vehicleheads.find(n => n.value === v);
      this.form = {
        _id: "",
        type: this.form.type,
        name: vehiclehead.text,
        chargingpile: "",
        vehiclehead: v,
        vehiclebody: "",
        vehicleouter: "",
        shortname: "",
        lnglat: vehiclehead.lnglat,
        address: vehiclehead.address,
        desc: "",
      };
    },
    changeVehicleBody(v) {
      console.log('changeVehicleBody', v);
      let vehiclebody = this.vehiclebodys.find(n => n.value === v);
      this.form = {
        _id: "",
        type: this.form.type,
        name: vehiclebody.text,
        chargingpile: "",
        vehiclehead: "",
        vehiclebody: v,
        vehicleouter: "",
        shortname: "",
        lnglat: vehiclebody.lnglat,
        address: vehiclebody.address,
        desc: "",
      };
    },
    changeVehicleOuter(v) {
      console.log('changeVehicleOuter', v);
      let vehicleouter = this.vehicleouters.find(n => n.value === v);
      this.form = {
        _id: "",
        type: this.form.type,
        name: vehicleouter.text,
        chargingpile: "",
        vehiclehead: "",
        vehiclebody: "",
        vehicleouter: v,
        shortname: "",
        lnglat: vehicleouter.lnglat,
        address: vehicleouter.address,
        desc: "",
      };
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/location/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    hide(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/location/hide", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    show(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/location/show", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/location/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-text-field__details {
  margin-bottom: 0 !important;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
